export const SCROLL_SLIDER_DEBOUNCE_TIME = 100

export const SCROLL_SLIDER_DRAG_THRESHOLD = 5 //px

export const SCROLL_SLIDER_WHEEL_LINE_HEIGHT = 16 //px
